"use client";

import React, { createContext, useContext, useState, ReactNode } from "react";

interface DialerState {
  isOpen: boolean;
  leadId?: string;
  leadName?: string;
  phoneNumber?: string;
}

interface DialerContextType {
  dialerState: DialerState;
  openDialer: (options?: { leadId?: string; leadName?: string; phoneNumber?: string }) => void;
  closeDialer: () => void;
}

const DialerContext = createContext<DialerContextType | undefined>(undefined);

export function DialerProvider({ children }: { children: ReactNode }) {
  const [dialerState, setDialerState] = useState<DialerState>({
    isOpen: false,
  });

  const openDialer = (options?: { leadId?: string; leadName?: string; phoneNumber?: string }) => {
    setDialerState({
      isOpen: true,
      leadId: options?.leadId,
      leadName: options?.leadName,
      phoneNumber: options?.phoneNumber,
    });
  };

  const closeDialer = () => {
    setDialerState({
      isOpen: false,
      leadId: undefined,
      leadName: undefined,
      phoneNumber: undefined,
    });
  };

  return (
    <DialerContext.Provider value={{ dialerState, openDialer, closeDialer }}>
      {children}
    </DialerContext.Provider>
  );
}

export function useDialer() {
  const context = useContext(DialerContext);
  if (!context) {
    throw new Error("useDialer must be used within a DialerProvider");
  }
  return context;
}
